var _circle, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#ed693a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "26.31 48.17 26.31 53 28.31 53 26.83 48.09"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "26.45 44 28.86 52.06 31.52 44"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "29.39 53 34.88 53 32.08 44.85"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "41.65 50.3 42.16 50.19 42.16 44 38.9 44"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "35.98 53 41.94 53 38.36 44.78"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "32.64 44 35.41 52.07 37.75 44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.23,30.06c-0.02-0.12,0.02-0.25,0.11-0.34l5.12-5.12c1.21-1.21,1.5-3.05,0.72-4.58 c-0.45-0.87-1.05-1.62-1.78-2.24l-6.39-5.38c-1.06-0.9-2.39-1.39-3.75-1.39c-0.85,0-1.7,0.2-2.45,0.58l-8.97,4.34 c-0.05,0.02-0.13,0.04-0.19,0.05l-5.15-0.09c-0.61,0-1.18,0.26-1.59,0.74l-3.42,3.95c-0.43,0.49-0.66,1.12-0.66,1.77v14.16 c0,1.21-0.98,2.19-2.19,2.19c-1.21,0-2.19-0.98-2.19-2.19v-0.77h-2.06v2.2c0,2.57,2.09,4.65,4.65,4.65s4.65-2.09,4.65-4.65v-8.78 c0-0.22,0.18-0.4,0.4-0.4c0.22,0,0.4,0.18,0.4,0.4v3.19l0.14,0.08c0.52,0.27,1,0.41,1.42,0.41c0.25,0,0.48-0.05,0.7-0.14 c1.23-0.56,1.57-2.53,1.58-2.55c0.26-0.85,0.54-1.97,0.85-3.33c0.77-3.45,1.43-7.36,1.51-7.78c0.04-0.19-0.05-0.38-0.2-0.46 c-0.18-0.1-0.37-0.14-0.57-0.14c-1.08,0-2.07,1.37-2.08,1.38c-0.08,0.11-0.19,0.17-0.32,0.17c-0.08,0-0.16-0.03-0.23-0.07 c-0.18-0.13-0.22-0.38-0.09-0.56c0.57-0.79,1.63-1.72,2.72-1.72c0.33,0,0.65,0.08,0.96,0.25c0.46,0.24,0.7,0.76,0.61,1.29 c-0.23,1.41-0.79,4.54-1.41,7.36l-0.04,0.19l4.28,2.37v-4.78c0-0.23,0.18-0.4,0.4-0.4c0.22,0,0.4,0.18,0.4,0.4V43.2h5.18V33.18 l-1.42-0.8c-0.52-0.29-0.89-0.77-1.04-1.35c-0.15-0.57-0.07-1.17,0.24-1.68l3.85-6.39c0.07-0.12,0.2-0.19,0.34-0.19 c0.07,0,0.14,0.02,0.2,0.05c0.19,0.12,0.25,0.36,0.14,0.55l-3.84,6.38c-0.2,0.33-0.26,0.71-0.16,1.08 c0.1,0.36,0.33,0.66,0.66,0.85l1.58,0.9l10.99,6.18l3.71-5.44l-6.11-2.96C46.33,30.31,46.25,30.2,46.23,30.06z M21.11,22.13 c-0.22,0-0.41-0.18-0.41-0.4c0-0.22,0.18-0.4,0.4-0.4h0.01c0.22,0,0.4,0.18,0.4,0.4C21.52,21.95,21.34,22.13,21.11,22.13z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f495d0b2f4fe6e48b7b5a01e26e97034.svg";
export { ForwardRef as ReactComponent };